import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Listings } from "@/components/Listings";
import { Services } from "@/components/Services";
import { Manifesto } from "@/components/Manifesto";
import { Estimator } from "@/components/Estimator";
import { Team } from "@/components/Team";
import { Testimonials } from "@/components/Testimonials";
import { Location } from "@/components/Location";
import { Contact } from "@/components/Contact";
import { FloatingWhatsApp } from "@/components/FloatingWhatsApp";
import Admin from "@/pages/Admin";
import Properties from "@/pages/Properties";
import PropertyDetail from "@/pages/PropertyDetail";

function Landing() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      if (window.__lenis === lenis) delete window.__lenis;
    };
  }, []);

  return (
    <div className="bg-[#faf9f5] text-[#131311] antialiased">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Listings />
        <Services />
        <Manifesto />
        <Estimator />
        <Team />
        <Testimonials />
        <Location />
      </main>
      <Contact />
      <FloatingWhatsApp />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/properties" element={<Properties />} />
        <Route path="/property/:id" element={<PropertyDetail />} />
        <Route path="/p/:id" element={<PropertyDetail />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
